"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
var tslib_1 = require("tslib");
var ui_butticon_1 = require("@hopin-team/ui-butticon");
var ui_char_count_1 = require("@hopin-team/ui-char-count");
var ui_field_error_message_1 = require("@hopin-team/ui-field-error-message");
var ui_field_helper_message_1 = require("@hopin-team/ui-field-helper-message");
var ui_field_label_1 = require("@hopin-team/ui-field-label");
var ui_flex_1 = require("@hopin-team/ui-flex");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var use_id_1 = require("@hopin-team/use-id");
var react_1 = tslib_1.__importStar(require("react"));
var actions_1 = require("./styled/actions");
var icon_1 = require("./styled/icon");
var input_1 = require("./styled/input");
var TextField = (0, react_1.forwardRef)(function (_a, ref) {
    var __UIScope = _a.__UIScope, autocomplete = _a.autocomplete, button = _a.button, butticon = _a.butticon, className = _a.className, _b = _a.clearText, clearText = _b === void 0 ? 'Clear input field' : _b, currentCount = _a.currentCount, errorMessage = _a.errorMessage, hasErrors = _a.hasErrors, helperText = _a.helperText, id = _a.id, isDisabled = _a.isDisabled, isReadOnly = _a.isReadOnly, isInverse = _a.isInverse, isRequired = _a.isRequired, label = _a.label, hideLabel = _a.hideLabel, icon = _a.icon, maxCount = _a.maxCount, _c = _a.multiLine, multiLine = _c === void 0 ? false : _c, name = _a.name, onChange = _a.onChange, onClear = _a.onClear, placeholder = _a.placeholder, _d = _a.requiredText, requiredText = _d === void 0 ? 'required' : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e, _f = _a.type, type = _f === void 0 ? 'text' : _f, props = tslib_1.__rest(_a, ["__UIScope", "autocomplete", "button", "butticon", "className", "clearText", "currentCount", "errorMessage", "hasErrors", "helperText", "id", "isDisabled", "isReadOnly", "isInverse", "isRequired", "label", "hideLabel", "icon", "maxCount", "multiLine", "name", "onChange", "onClear", "placeholder", "requiredText", "size", "type"]);
    var _id = (0, use_id_1.useId)(id);
    var fieldId = "field-".concat(_id);
    var charCountId = "char-count-".concat(_id);
    var errorMsgId = "error-msg-".concat(_id);
    var helperMsgId = "helper-msg-".concat(_id);
    var _g = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: 'TextField',
        className: className,
        __UIScope: __UIScope,
    }), makeClasses = _g.makeClasses, rootClasses = _g.rootClasses;
    var inputRef = (0, react_1.useRef)(null);
    var _h = tslib_1.__read((0, react_1.useState)(false), 2), isShowingClear = _h[0], setIsShowingClear = _h[1];
    var handleClear = function () {
        var _a;
        var value = (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.value;
        if (inputRef && inputRef.current && value) {
            inputRef.current.value = '';
            setIsShowingClear(false);
            inputRef.current.focus();
        }
        onClear === null || onClear === void 0 ? void 0 : onClear();
    };
    var handleOnChange = function (e) {
        var value = e.target.value;
        value ? setIsShowingClear(true) : setIsShowingClear(false);
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    var withErrorMessage = hasErrors && errorMessage;
    var withHelperMessage = !hasErrors && helperText;
    var withCharCount = typeof currentCount === 'number' && typeof maxCount === 'number';
    var a11yProps = {};
    if (withErrorMessage) {
        a11yProps['aria-describedby'] = errorMsgId;
    }
    if (withHelperMessage) {
        a11yProps['aria-describedby'] = helperMsgId;
    }
    if (withCharCount) {
        a11yProps['aria-describedby'] = charCountId;
    }
    if (hideLabel) {
        a11yProps['aria-label'] = label;
    }
    var inputProps = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, a11yProps), props), (multiLine ? {} : { type: type }));
    var tagName = multiLine ? 'textarea' : 'input';
    var justifyContent = (withHelperMessage || withErrorMessage) && withCharCount
        ? 'space-between'
        : !withHelperMessage && !withErrorMessage && withCharCount
            ? 'flex-end'
            : 'flex-start';
    // Measures the width of any button / butticon children
    // and the clear button for the input field's padding-right
    var actionsRef = (0, react_1.useRef)(null);
    var _j = tslib_1.__read((0, react_1.useState)(0), 2), actionsWidth = _j[0], setActionsWidth = _j[1];
    (0, react_1.useEffect)(function () {
        var _a, _b;
        var width = (_b = (_a = actionsRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 0;
        setActionsWidth(Math.ceil(width / 16) + 2.5);
    }, [actionsRef]);
    return (react_1.default.createElement("div", { className: rootClasses },
        !hideLabel && (react_1.default.createElement(ui_field_label_1.FieldLabel, { className: makeClasses('Label'), fieldId: fieldId, isDisabled: isDisabled, isInverse: isInverse, isRequired: isRequired, label: label, requiredText: requiredText, mb: 0.5 })),
        react_1.default.createElement(ui_flex_1.Flex, { isRelative: true, alignItems: "center" },
            react_1.default.createElement(input_1.Input, tslib_1.__assign({ as: tagName, className: makeClasses('Input'), "aria-invalid": hasErrors, disabled: isDisabled, hasErrors: hasErrors, id: fieldId, onChange: handleOnChange, name: name, placeholder: placeholder, ref: function (node) {
                    if (node) {
                        inputRef.current = node;
                        if (ref) {
                            if (typeof ref === 'function') {
                                ref(node);
                            }
                            else {
                                ref.current = node;
                            }
                        }
                    }
                }, required: isRequired, sizeOption: size, autoComplete: autocomplete, hasIcon: Boolean(icon), maxLength: maxCount, isInverse: isInverse, readOnly: isReadOnly, actionsWidth: actionsWidth }, inputProps)),
            icon && (react_1.default.createElement(icon_1.Icon, { name: icon, color: isInverse ? 'grey-400' : 'grey-600', "aria-hidden": true })),
            react_1.default.createElement(actions_1.Actions, { ref: actionsRef },
                isShowingClear && (react_1.default.createElement(ui_butticon_1.Butticon, { className: makeClasses('Clear'), type: "reset", icon: "close-circle", title: clearText, size: size === 'small' ? 'tiny' : 'small', pattern: isInverse ? 'inverse' : undefined, onClick: handleClear })),
                button && !butticon && button,
                butticon && !button && butticon)),
        react_1.default.createElement(ui_flex_1.Flex, { justifyContent: justifyContent },
            hasErrors && errorMessage && (react_1.default.createElement(ui_field_error_message_1.FieldErrorMessage, { className: makeClasses('ErrorMessage'), mt: 1, errorMessage: errorMessage, id: errorMsgId, isInverse: isInverse })),
            !hasErrors && helperText && (react_1.default.createElement(ui_field_helper_message_1.FieldHelperMessage, { helperMessage: helperText, mt: 1, className: makeClasses('HelperMessage'), id: helperMsgId, isInverse: isInverse })),
            withCharCount && (react_1.default.createElement(ui_char_count_1.CharCount, { className: makeClasses('CharCount'), currentCount: currentCount, maxCount: maxCount, id: charCountId, mt: 1 })))));
});
TextField.displayName = 'TextField';
var TextFieldWithSpace = (0, ui_helper_with_space_1.withSpace)(TextField);
exports.TextField = TextFieldWithSpace;
//# sourceMappingURL=text-field.js.map